import React, { useState } from "react";
import Editor from "../components/Editor";
import { useNavigate } from "react-router-dom";
import Spinner from "../components/Spinner";

const NewPost = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [summary, setSummary] = useState("");
  const [files, setFiles] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (ev) => {
    let image = files[0];
    const data = new FormData();
    data.set("title", title);
    data.set("summary", summary);
    data.set("content", content);
    data.set("file", image);
    ev.preventDefault();
    setIsLoading(true);
    const response = await fetch(
      "https://iblog-connect.vercel.app/blogs/post",
      {
        method: "POST",
        body: data,
        headers: {
          token: localStorage.getItem("token"),
        },
        credentials: "include",
      }
    );
    setIsLoading(false);
    if (response.ok) {
      navigate("/");
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <form className="login-form create-form" onSubmit={handleSubmit}>
        <h2
          style={{ paddingBottom: "2.5em" }}
          onClick={() => {
            navigate("/");
          }}
        >
          Write a blog
        </h2>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(ev) => setTitle(ev.target.value)}
          required
        />
        <input
          type="text"
          placeholder="summary"
          value={summary}
          onChange={(ev) => setSummary(ev.target.value)}
        />
        <input
          type="file"
          placeholder="Select"
          accept=".jpg, .jpeg, .png"
          max={1048576}
          onChange={(ev) => setFiles(ev.target.files)}
        />
        {files[0] && files[0].size > 3 * 1024 * 1024 && (
          <p style={{ color: "red", marginTop: 0 }}>
            File size is larger than 3MB!
          </p>
        )}
        <Editor value={content} onChange={setContent} />
        <button
          style={{ margin: "auto", width: "30%" }}
          disabled={isLoading || (files[0] && files[0].size > 3 * 1024 * 1024)}
        >
          Create
        </button>
      </form>
    </div>
  );
};

export default NewPost;
